import { Box, Divider, IconButton, Tooltip, Typography } from "@mui/material";
import React from "react";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";

export default function ChildSafetyStandards(props) {
  const isMobileView = window.innerWidth < 600;
  return (
    <Box sx={{ padding: isMobileView ? "16px 20px" : "60px 200px" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
        }}
      >
        <Tooltip title="GO BACK">
          <IconButton aria-label="delete" sx={{ mr: "16px" }} onClick={e => {
            props?.history?.goBack()
          }}>
            <ChevronLeftIcon />
          </IconButton>
        </Tooltip>

        <Typography
          variant={isMobileView ? "h5" : "h4"}
          color={"#000000"}
          fontWeight="bold"
          textAlign={"left"}
        >
          Child Safety Standards: Updated on 8-Sep-2026
        </Typography>
      </Box>
      <Divider
        sx={{
          borderColor: "rgba(102, 51, 153, 0.3)",
          my: "16px",
          mb: "30px",
        }}
      />
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: isMobileView ? "100%" : "80%",
          flexDirection: isMobileView ? "column" : "row",
          color: "#000",
        }}
      >
        <div style={{ textAlign: "justify" }}>
          <p>
            <b>App:</b> UM VVS Madhwa Matrimony<br />
            <b>Service:</b> Vadhu Vara Samyojana (VVS)<br />
            <b>Developer/Organization:</b> Jaya Satya Pramoda Nidhi (JSPN)<br />
            <b>Website:</b> srijspnvvs.umapps.in
          </p>

          <Typography variant="h4" color={"#000000"} fontWeight="bold" textAlign={isMobileView ? "center" : "left"}>
            1. Our Commitment to Child Safety
          </Typography>
          <Divider sx={{ borderColor: "rgba(102, 51, 153, 0.3)", my: "16px", mb: "30px" }} />
          <p>
            Jaya Satya Pramoda Nidhi (JSPN), which operates Vadhu Vara Samyojana (VVS) and the UM VVS Madhwa
            Matrimony app, is committed to maintaining a safe environment for all users.
          </p>
          <p>
            VVS has zero tolerance for Child Sexual Abuse and Exploitation (CSAE) and strictly prohibits any
            activity involving the sexual abuse, sexual exploitation, grooming, or endangerment of children.
          </p>

          <hr />

          <Typography variant="h4" color={"#000000"} fontWeight="bold" textAlign={isMobileView ? "center" : "left"}>
            2. Prohibited Content and Conduct
          </Typography>
          <Divider sx={{ borderColor: "rgba(102, 51, 153, 0.3)", my: "16px", mb: "30px" }} />
          <p>The following activities are strictly prohibited on UM VVS Madhwa Matrimony and VVS:</p>
          <ul style={{ paddingLeft: 20, paddingRight: 20 }}>
            <li>Child Sexual Abuse and Exploitation (CSAE).</li>
            <br />
            <li>Creation, upload, sharing, distribution, solicitation, or possession of Child Sexual Abuse Material (CSAM).</li>
            <br />
            <li>Sexual content involving children or minors.</li>
            <br />
            <li>Sexual solicitation or exploitation of children.</li>
            <br />
            <li>Grooming or attempts to establish inappropriate sexual relationships with children.</li>
            <br />
            <li>Using VVS to facilitate, arrange, promote, or participate in the sexual exploitation of children.</li>
            <br />
            <li>Any communication, profile, photograph, message, or other content that sexually abuses, exploits, or endangers a child.</li>
            <br />
            <li>Attempting to circumvent VVS's age or profile-verification requirements for any prohibited purpose.</li>
            <br />
          </ul>
          <p>
            Any account or content found to violate these requirements may be removed, restricted, suspended, or
            permanently terminated.
          </p>

          <hr />

          <Typography variant="h4" color={"#000000"} fontWeight="bold" textAlign={isMobileView ? "center" : "left"}>
            3. Adult Matrimonial Service
          </Typography>
          <Divider sx={{ borderColor: "rgba(102, 51, 153, 0.3)", my: "16px", mb: "30px" }} />
          <p>
            VVS is an adult matrimonial service intended for individuals who meet the applicable legal
            marriageable-age requirements.
          </p>
          <p>
            Profiles created by underage persons are not permitted. VVS already maintains profile-validation
            procedures and rejects profiles created by underage persons or profiles containing abusive or
            inappropriate content.
          </p>
          <p>
            Users must provide accurate information during registration and must not misrepresent their age or
            identity.
          </p>

          <hr />

          <Typography variant="h4" color={"#000000"} fontWeight="bold" textAlign={isMobileView ? "center" : "left"}>
            4. Reporting Child Safety Concerns
          </Typography>
          <Divider sx={{ borderColor: "rgba(102, 51, 153, 0.3)", my: "16px", mb: "30px" }} />
          <p>
            Users can report suspected child sexual abuse, exploitation, grooming, CSAM, or other child-safety
            concerns to VVS through the available reporting mechanisms within the platform or by contacting our
            Child Safety Point of Contact.
          </p>
          <p>Reports may include concerns regarding:</p>
          <ul style={{ paddingLeft: 20, paddingRight: 20 }}>
            <li>A user profile;</li>
            <br />
            <li>A photograph or other uploaded content;</li>
            <br />
            <li>A message or communication;</li>
            <br />
            <li>Suspected grooming or exploitation;</li>
            <br />
            <li>A suspected underage account; or</li>
            <br />
            <li>Any other activity that may place a child at risk.</li>
            <br />
          </ul>
          <p>Users should provide sufficient information to help VVS investigate the concern.</p>

          <hr />

          <Typography variant="h4" color={"#000000"} fontWeight="bold" textAlign={isMobileView ? "center" : "left"}>
            5. Handling Reports and Violating Content
          </Typography>
          <Divider sx={{ borderColor: "rgba(102, 51, 153, 0.3)", my: "16px", mb: "30px" }} />
          <p>JSPN/VVS takes reports concerning child safety seriously and prioritizes appropriate action.</p>
          <p>Where a violation is identified or reasonably suspected, VVS may:</p>
          <ul style={{ paddingLeft: 20, paddingRight: 20 }}>
            <li>Remove or restrict access to the reported content;</li>
            <br />
            <li>Suspend or permanently terminate the relevant account;</li>
            <br />
            <li>Prevent the creation of further accounts where appropriate;</li>
            <br />
            <li>Preserve relevant information where required or legally appropriate; and</li>
            <br />
            <li>Report matters to appropriate law-enforcement authorities or other relevant organizations where required by applicable law.</li>
            <br />
          </ul>
          <p>
            VVS may also take preventive action where necessary to protect users and maintain the safety and
            integrity of the platform.
          </p>

          <hr />

          <Typography variant="h4" color={"#000000"} fontWeight="bold" textAlign={isMobileView ? "center" : "left"}>
            6. Profile Verification and Safety Measures
          </Typography>
          <Divider sx={{ borderColor: "rgba(102, 51, 153, 0.3)", my: "16px", mb: "30px" }} />
          <p>
            VVS uses email and mobile-number verification as part of its profile registration and validation
            process.
          </p>
          <p>
            Profiles are reviewed and may be rejected where they contain abusive content, invalid information,
            misleading information, or are created by underage persons.
          </p>
          <p>
            Users are encouraged to report profiles or information that they believe is inaccurate,
            inappropriate, abusive, or potentially harmful.
          </p>

          <hr />

          <Typography variant="h4" color={"#000000"} fontWeight="bold" textAlign={isMobileView ? "center" : "left"}>
            7. User-Generated Content
          </Typography>
          <Divider sx={{ borderColor: "rgba(102, 51, 153, 0.3)", my: "16px", mb: "30px" }} />
          <p>
            Users are responsible for the information, photographs, communications, and other content they submit
            to VVS.
          </p>
          <p>
            Content that violates these Child Safety Standards may be removed, and the associated account may be
            restricted or terminated.
          </p>
          <p>
            VVS does not permit users to use its matrimonial service for any activity involving child sexual abuse
            or exploitation.
          </p>

          <hr />

          <Typography variant="h4" color={"#000000"} fontWeight="bold" textAlign={isMobileView ? "center" : "left"}>
            8. Child Safety Point of Contact
          </Typography>
          <Divider sx={{ borderColor: "rgba(102, 51, 153, 0.3)", my: "16px", mb: "30px" }} />
          <p>For child-safety-specific concerns, reports, or inquiries, please contact:</p>
          <p>
            <b>Child Safety Point of Contact</b><br />
            <b>Organization:</b> Jaya Satya Pramoda Nidhi (JSPN)<br />
            <b>Service:</b> Vadhu Vara Samyojana (VVS)<br />
            <b>Email:</b> <a href="mailto:jspn.vvs@umapps.in">jspn.vvs@umapps.in</a><br />
            <b>WhatsApp:</b> <a href="https://wa.me/message/BN2R4ZFIMY4JM1">+91 63639 21008</a>
          </p>
          <p>Child-safety concerns should be clearly identified in the subject or message so that they can be appropriately prioritized.</p>

          <hr />

          <Typography variant="h4" color={"#000000"} fontWeight="bold" textAlign={isMobileView ? "center" : "left"}>
            9. Compliance With Applicable Laws
          </Typography>
          <Divider sx={{ borderColor: "rgba(102, 51, 153, 0.3)", my: "16px", mb: "30px" }} />
          <p>
            Jaya Satya Pramoda Nidhi (JSPN) is committed to complying with applicable child-safety laws and
            regulations.
          </p>
          <p>
            Where legally required, JSPN/VVS will cooperate with appropriate authorities and take necessary action
            concerning suspected child sexual abuse, exploitation, or related unlawful activity.
          </p>

          <hr />

          <Typography variant="h4" color={"#000000"} fontWeight="bold" textAlign={isMobileView ? "center" : "left"}>
            10. Application of These Standards
          </Typography>
          <Divider sx={{ borderColor: "rgba(102, 51, 153, 0.3)", my: "16px", mb: "30px" }} />
          <p>
            These Child Safety Standards apply to UM VVS Madhwa Matrimony and the Vadhu Vara Samyojana (VVS)
            service operated by Jaya Satya Pramoda Nidhi (JSPN).
          </p>
          <p>
            These standards supplement the VVS Terms &amp; Conditions and other applicable policies governing use
            of the platform.
          </p>
          <p>
            Jaya Satya Pramoda Nidhi (JSPN)<br />
            C/o. Uttaradi Math, Jayateertha Vidyapeetha<br />
            Uttaradi Math Road<br />
            Basavanagudi, Bangalore – 560 004
          </p>
          <p>
            <b>Email:</b> <a href="mailto:jspn.vvs@umapps.in">jspn.vvs@umapps.in</a>
          </p>
          <hr />
        </div>
      </Box>
    </Box>
  );
}
